import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-play\"><defs><style type=\"text/css\"></style></defs><path d=\"M341.333333 219.306667v597.333333l469.333334-298.666667-469.333334-298.666666z\" fill=\"\" p-id=\"21220\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol